import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-customer-service',
  templateUrl: './customer-service.component.html'
})
export class CustomerServiceComponent implements OnInit {
  
  private client: string;
  private appconfig = environment.appconfig;
  private appextconfig = environment.appextconfig;

  constructor(private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.client = "";

    if (document.referrer && document.referrer.includes("theconnoisseurclub.com")) {
      this.client = "foodnwine";
    } else if (document.referrer && document.referrer.includes("skyguideclub.com")) {
      this.client = "skyguide";
    } else if (document.referrer && document.referrer.includes("golfplayersclub.com")) {
      this.client = "golf";
    } else if (document.referrer && document.referrer.includes("tlelitetraveler.com")) {
      this.client = "elite";
    }
    if (this.client == "") {
      this.router.navigate(['/search'], { relativeTo: this.route });
    }
  }

}



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/customer-service/customer-service.component.ts